"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductInfo = void 0;
const utils_1 = require("../../utils/utils");
const base_component_1 = require("../../components/base-component");
const debounce_1 = require("../../utils/debounce");
const check_media_1 = require("../../utils/check-media");
const SCROLLTRACK_ATTRIBUTE = 'data-with-scrolltrack';
const HEADER_SELECTOR = 'header-component';
const SMALL_CLASS = 'product__info-wrapper--small';
const WIDE_CLASS = 'product__info-wrapper--wide';
const WIDE_PLUS_CLASS = 'product__info-wrapper--wide-plus';
class ProductInfo extends base_component_1.BaseComponent {
    headerHeight;
    defaultTopSpace;
    infoHeight;
    isToSetMoreHeight;
    resizeObserver;
    mountComponent() {
        const isWithScrollTrack = this.hasAttribute(SCROLLTRACK_ATTRIBUTE);
        if (isWithScrollTrack) {
            customElements.whenDefined('header-component').then(() => {
                this.setDimentions();
                this.addListener(window, 'scroll', this.handleScroll);
            });
            if (this.isEditor) {
                this.editor.on('SECTION_LOAD', this.handleSectionLoad);
            }
        }
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this);
    }
    setDimentions = () => {
        this.defaultTopSpace = 16;
        this.infoHeight = this.getBoundingClientRect().height;
        const header = (0, utils_1.$el)(HEADER_SELECTOR);
        const headerSection = header.section;
        this.headerHeight = headerSection.offsetHeight;
        this.isToSetMoreHeight = header.getAttribute('is-sticky') === 'static';
    };
    handleScroll = () => {
        const topSpace = this.isToSetMoreHeight
            ? this.defaultTopSpace + this.headerHeight
            : this.defaultTopSpace;
        const viewportHeight = window.innerHeight - topSpace;
        if (window.scrollY > 0 && this.infoHeight > viewportHeight) {
            this.style.top = `${viewportHeight - this.infoHeight}px`;
        }
        else {
            this.style.top = `${topSpace}px`;
        }
    };
    handleSectionLoad = () => {
        this.setDimentions();
    };
    handleResize = (0, debounce_1.debounce)(() => {
        if (!(0, check_media_1.isMobile)()) {
            this.toggleWidthClasses();
        }
    }, 50);
    toggleWidthClasses = () => {
        const infoWidth = this.getBoundingClientRect().width;
        this.classList.toggle(SMALL_CLASS, infoWidth < 380);
        this.classList.toggle(WIDE_CLASS, infoWidth > 480);
        this.classList.toggle(WIDE_PLUS_CLASS, infoWidth > 740);
    };
}
exports.ProductInfo = ProductInfo;
